export const apiResourceLinks = {
    isProfileComplete: '/is-profile-complete/v1',
    getAccountChangeRequests: '/acr/Pagination',
    getAccountChangeRequest: '/acr/get-request',
    getLimits: '/limits/get-limits-for-accounts',
    getLimit: '/limits/get-limits-for-account',
    getRiskLimitRequests: '/limits/get-requests',
    getRiskLimitRequest: '/limits/get-request',
    getKybRequests: '/limits/kyb-requests',
    cancelAcr: '/acr/cancel-acr',
    cancelRisk: '/limits/cancel-request',
    createChangeLimitsRequest: '/limits/create-request',
    myUser: '/acr/my-user',
    getProductList: '/limits/get-products',
    generalSupport: '/GeneralSupport',
    generalSupportMessage: '/GeneralSupport/Message',
    cashMovementRequests: '/PaymentRequest',
    receiptAllocation: '/ReceiptAllocation',
    checkFunds: '/PaymentRequest/CheckFunds',
    cashMovementRequestsPagination: '/CashMovement/Activity/Pagination',
    office: '/Office',
    getAccounts: '/Account',
    getStandardSettlementInstruction: '/SettlementReference',
    getUsdExchangeRate: '/PaymentRequest/UsdExchangeRate',
    latestRequests: '/LatestRequests'
};
